<div class="container-fluid">
<mat-divider class="mb-3"></mat-divider>
  <form [formGroup]="antecedentesForm" (ngSubmit)="onSubmit()" class="row">
    <h3>Cargo Público</h3>
    <div class="row">
      
      <mat-checkbox formControlName="esCargoPublico" class="col-md-3" appearance="outline" (change)="cambioEsCargoPublico($event)">Poseo cargo público</mat-checkbox>
      <mat-checkbox formControlName="familiarCargoPublico" class="col-md-3"
        (change)="cambioEsCargoPublico($event)">Tengo un familiar en cargo público</mat-checkbox>

      <mat-form-field class="col-md-3" appearance="outline">
        <mat-label>Institución Pública</mat-label>
        <input matInput formControlName="institucionPublico" placeholder="Institución Pública">
      </mat-form-field>

      <mat-form-field class="col-md-3" appearance="outline">
        <mat-label>Cargo en Ámbito Público</mat-label>
        <input matInput formControlName="cargoPublico" placeholder="Cargo en Ámbito Público">
      </mat-form-field>
      <mat-divider class="mb-3"></mat-divider>
    </div>
    
    <h3>Actividad</h3>
    <div class="row">
      <mat-form-field class="col-md-3" appearance="outline">
        <mat-label>Actividad Principal</mat-label>
        <mat-select formControlName="tipoActividadPrincipal" (valueChange)="actividadPrincipalChange($event)">
        <mat-option *ngFor="let tipo of getTipoActividadPrincipalKeys()" [value]="tipo">{{ tiposActividadPrincipal[tipo]
          }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="col-md-3" appearance="outline">
      <mat-label>Otra Actividad Principal</mat-label>
      <input matInput formControlName="otroTipoActividadPrincipal" placeholder="Otra Actividad Principal">
    </mat-form-field>
    <mat-form-field class="col-md-3" appearance="outline">
      <mat-label>Nivel de Estudios</mat-label>
      <mat-select formControlName="tipoNivelEstudios" (valueChange)="nivelEstudiosChange($event)">
        <mat-option *ngFor="let tipo of getTipoNivelEstudiosKeys()" [value]="tipo">{{ tiposNivelEstudios[tipo]
          }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="col-md-3" appearance="outline">
      <mat-label>Profesión o Carrera</mat-label>
      <input matInput formControlName="profesionCarrera" placeholder="Profesión o Carrera">
    </mat-form-field>
    <mat-divider class="mb-3"></mat-divider>
  </div>

    <h3>Estudios Superiores</h3>
    <div class="row">
      <mat-form-field class="col-md-3" appearance="outline">
        <mat-label>Tipo Carrera</mat-label>
        <mat-select formControlName="tipoCarrera" (valueChange)="tipoCarreraChange($event)">
          <mat-option *ngFor="let tipo of getTipoCarreraKeys()" [value]="tipo">{{ tiposCarrera[tipo] }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="col-md-4" appearance="outline">
        <mat-label>Duración de la Carrera (años)</mat-label>
        <input matInput formControlName="duracionCarrera" placeholder="Duración de la Carrera (años)" type="text"  pattern="[0-9]*" inputmode="numeric"  min="1" max="10">
      </mat-form-field>

      <mat-form-field class="col-md-3" appearance="outline">
        <mat-label>Año que Cursa</mat-label>
        <input matInput type="text" max="10" min="0"  pattern="[0-9]*" inputmode="numeric"  formControlName="anoActualCarrera" placeholder="Año que Cursa">
      </mat-form-field>

      <mat-form-field class="col-md-3" appearance="outline">
        <mat-label>Institución Educacional</mat-label>
        <input matInput formControlName="institucionEducacional" placeholder="Institución Educacional">
      </mat-form-field>
    </div>

    <mat-divider class="mb-3"></mat-divider>
    <h3>Datos Empleo / Actividad</h3>
    <div class="row">

    <mat-form-field class="col-md-3" appearance="outline">
      <mat-label>RUT</mat-label>
      <input matInput formControlName="rutEmpleado" placeholder="XXXXXXXX-X">
    </mat-form-field>
  
    <mat-form-field class="col-md-3" appearance="outline">
      <mat-label>Nombre</mat-label>
      <input matInput formControlName="nombreEmpleador" placeholder="Nombre">
    </mat-form-field>

    <mat-checkbox formControlName="socio" class="col-md-2">Soy Socio</mat-checkbox>

    <mat-form-field class="col-md-3" appearance="outline">
      <mat-label>Cargo o Actividad</mat-label>
      <input matInput formControlName="cargoActividad" placeholder="Cargo o Actividad">
    </mat-form-field>

    <mat-form-field class="col-md-4" appearance="outline">
      <mat-label>Fecha de Inicio</mat-label>
      <input matInput formControlName="fechaInicio" [matDatepicker]="picker" placeholder="Ingresa MM-DD-AAAA" [max]="hoy">
      <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
    <mat-divider class="mb-3"></mat-divider>
    <h3 class="card-title">Sostenedor Económico</h3>
    <div class="row" formGroupName="sostenedorEconomico">
      
      <mat-form-field class="col-md-3" appearance="outline">
        <mat-label>RUT</mat-label>
        <input matInput formControlName="rut" placeholder="XXXXXXXX-X">
      </mat-form-field>

      <mat-form-field class="col-md-3" appearance="outline">
        <mat-label>Nombre</mat-label>
        <input matInput formControlName="nombre" placeholder="Nombre">
      </mat-form-field>

      <mat-form-field class="col-md-3" appearance="outline">
        <mat-label>Apellido Paterno</mat-label>
        <input matInput formControlName="apellidoPaterno" placeholder="Apellido Paterno">
      </mat-form-field>

      <mat-form-field class="col-md-3" appearance="outline">
        <mat-label>Apellido Materno</mat-label>
        <input matInput formControlName="apellidoMaterno" placeholder="Apellido Materno">
      </mat-form-field>

      <mat-form-field class="col-md-3" appearance="outline">
        <mat-label>Dirección</mat-label>
        <input matInput formControlName="direccion" placeholder="Dirección">
      </mat-form-field>

      <mat-form-field class="col-md-3" appearance="outline">
        <mat-label>Cargo o Actividad</mat-label>
        <input matInput formControlName="actividad" placeholder="Cargo o Actividad">
      </mat-form-field>
    </div>

    <mat-divider class="mb-3"></mat-divider>
    <h3>Ingresos Líquidos Mensuales</h3>
    <div class="row">
      
      <mat-form-field class="col-md-2" appearance="outline">
        <mat-label>Sueldo</mat-label>
        <input matInput formControlName="sueldo" placeholder="$" currencyMask type="text" (keyup)="sumaIngresos()">
      </mat-form-field>

      <mat-form-field class="col-md-2" appearance="outline">
        <mat-label>Honorarios</mat-label>
        <input matInput formControlName="honorarios" placeholder="$" currencyMask type="text" (keyup)="sumaIngresos()">
      </mat-form-field>

      <mat-form-field class="col-md-2" appearance="outline">
        <mat-label>Retiros</mat-label>
        <input matInput formControlName="retiros" placeholder="$" currencyMask type="text" (keyup)="sumaIngresos()">
      </mat-form-field>

      <mat-form-field class="col-md-2" appearance="outline">
        <mat-label>Arriendos</mat-label>
        <input matInput formControlName="arriendos" placeholder="$" currencyMask type="text" (keyup)="sumaIngresos()">
      </mat-form-field>

      <mat-form-field class="col-md-2" appearance="outline">
        <mat-label>Otros Ingresos</mat-label>
        <input matInput formControlName="otros" placeholder="$" currencyMask type="text" (keyup)="sumaIngresos()">
      </mat-form-field>

      <mat-form-field class="col-md-2" appearance="outline">
        <mat-label>Total Ingresos</mat-label>
        <input matInput formControlName="totalIngresos" placeholder="$" currencyMask type="text" readonly>
      </mat-form-field>
    </div>
    <div class="row">
      <div class="mt-4">
        <button id="antecedentesOCSiguientesbtn" type="submit" mat-raised-button color="primary" class="ml1 mr1 fr">Siguiente</button>
      <button id="antecedentesOCSVolver" type="button" mat-raised-button color="secundary" class="ml1 mr1 fr" (click)="volver()">Volver</button>
      </div>
    </div>
   
  </form>
</div>